export const initialCostsState = () => ({
    restaurant: '',
    gas: '',
    grocery: '',
    travel: '',
    recreation: '',
    other: '',
    isManualCost: false
});
